import { Dispatch } from "@reduxjs/toolkit";
import {
  getGalleryModalData,
  updateBasicDetails,
  getGalleryCarouselData,
  getVideoModalData,
  getRoomMediaModalData,
  closeRoomMediaModal,
  getRoomDetailsPanelData,
  closeRoomDetailsPanel,
  setShowShareModalData,
  setShowNextRoomButton,
} from "./propertyPageReducer";

class PropertyPageDispatcher {
  private dispatch;

  constructor(dispatch: Dispatch) {
    this.dispatch = dispatch;
  }

  showGalleryModal(data: any) {
    this.dispatch(getGalleryModalData(data));
  }

  updateBasicDetails(data: any) {
    this.dispatch(updateBasicDetails(data));
  }

  showGalleryCarousel(data: any) {
    this.dispatch(getGalleryCarouselData(data));
  }

  showVideoModal(data: any) {
    this.dispatch(getVideoModalData(data));
  }

  showRoomMediaModal(data: any) {
    this.dispatch(getRoomMediaModalData(data));
  }

  closeRoomMediaModal() {
    this.dispatch(closeRoomMediaModal());
  }

  showRoomDetailsPanel(data: {
    show: boolean;
    roomId: number | string | null;
    openSource: "view_more_details" | "arrow_next" | "arrow_prev";
  }) {
    this.dispatch(getRoomDetailsPanelData(data));
  }

  closeRoomDetailsPanel() {
    this.dispatch(closeRoomDetailsPanel());
  }

  showShareModal(data: boolean | { show: boolean; url: string }) {
    this.dispatch(setShowShareModalData(data));
  }

  showNextRoomButton(data: any) {
    this.dispatch(setShowNextRoomButton(data));
  }
}
export default PropertyPageDispatcher;
